import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Collection {
  _id: string;
  title: string;
  description: string;
  category: string;
  flashcardCount: number;
  createdAt: string;
  updatedAt: string;
}

interface CollectionsState {
  collections: Collection[];
  activeCollection: Collection | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: CollectionsState = {
  collections: [],
  activeCollection: null,
  isLoading: false,
  error: null,
};

// Thunks will be implemented when we create the collections service

export const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {
    setCollections: (state, action: PayloadAction<Collection[]>) => {
      state.collections = action.payload;
      state.error = null;
    },
    setActiveCollection: (state, action: PayloadAction<Collection>) => {
      state.activeCollection = action.payload;
      state.error = null;
    },
    addCollection: (state, action: PayloadAction<Collection>) => {
      state.collections.push(action.payload);
      state.error = null;
    },
    updateCollection: (state, action: PayloadAction<Collection>) => {
      const index = state.collections.findIndex(c => c._id === action.payload._id);
      if (index !== -1) {
        state.collections[index] = action.payload;
      }
      if (state.activeCollection?._id === action.payload._id) {
        state.activeCollection = action.payload;
      }
      state.error = null;
    },
    removeCollection: (state, action: PayloadAction<string>) => {
      state.collections = state.collections.filter(c => c._id !== action.payload);
      if (state.activeCollection?._id === action.payload) {
        state.activeCollection = null;
      }
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { 
  setCollections, 
  setActiveCollection, 
  addCollection, 
  updateCollection, 
  removeCollection,
  setLoading,
  setError,
} = collectionsSlice.actions;

export default collectionsSlice.reducer;